module.exports = __webpack_public_path__ + "static/media/no_insight.9b479c58.png";